import EditRole from './EditRole'

export default EditRole
